import styled from 'styled-components';
import { Modal, ModalBody } from 'reactstrap';
import { Button } from '@shoflo/polymer/components/Button/Button';
const widthPercentage = 80;
const heightPercentage = 80;

export const StyledModal = styled(Modal)`
  width: ${widthPercentage}%;
  max-width: none;
  height: ${heightPercentage}%;

  .modal-content {
    height: 100%;
  }
`;

export const StyledModalBody = styled(ModalBody)`
  height: ${heightPercentage}%;
`;
export const StyledCloseButton = styled(Button)`
  &:focus {
    color: #5c626d;
    background-color: #ffffff;
    outline: none;
  }
`;
